import { footerColumns } from "@/mocks/home";

const anchorMap: Record<string, string> = {
  历史记录: "#timeline",
  往期合集: "#collections",
  补课热榜: "#ranking",
  归档索引: "#index",
};

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
                黑
              </span>
              <span className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                黑料在线
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-foreground-700">
              把零散的线索按时间线归档，做成能随时回看的记录与往期合集。这里只做整理与索引，方便补全事件前后脉络。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="h-8 px-3 rounded-full bg-secondary-200 text-secondary-800 text-xs inline-flex items-center whitespace-nowrap">
                历史记录
              </span>
              <span className="h-8 px-3 rounded-full bg-secondary-200 text-secondary-800 text-xs inline-flex items-center whitespace-nowrap">
                往期合集
              </span>
              <span className="h-8 px-3 rounded-full bg-secondary-200 text-secondary-800 text-xs inline-flex items-center whitespace-nowrap">
                存档回看
              </span>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title} className="md:col-span-3">
              <h3 className="font-heading text-sm font-semibold text-foreground-950">
                {column.title}
              </h3>
              <ul className="mt-4 flex flex-col gap-3">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href={anchorMap[link] || "#top"}
                      className="text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1" />
        </div>
      </div>

      <div className="border-t border-secondary-200">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © 2026 黑料在线 · 内容为整理归档，信息标注仅供参考
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <a href="#top" className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              返回顶部
            </a>
            <a href="#faq" className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              归档说明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}